import { useState, useEffect } from 'react'
import {
  DeliverySelectorType,
  ButtonStatus,
  TitleProps
} from '@smuchile/pkg-unimarc-components'
import {
  eventClick,
  getStoresAddress,
  postCoordsValidate,
  useEvents,
  useOrderForm,
  useTrigerEvent,
  useUpdateAddress,
  validateWindow
} from '@smuchile/pkg-unimarc-hooks'
import { getGlobalStyle } from '@smuchile/pkg-unimarc-components/helpers'

interface StoreAddress {
  addressId: string
  addressType: string
  city: string
  country: string
  formatedAddress: string
  geoCoordinates: Array<number>
  id: string
  name: string
  neighborhood: string
  number: string
  region: string
  state: string
  street: string
}

enum AddressType {
  Delivery = 'residential',
  Store = 'pickup-in-point'
}

const removeItem = (arr: string[], region: string): string[] => {
  return arr.filter((currentRegion) => {
    return currentRegion !== region
  })
}

export const DeliverySelectorTypeComponent = (): React.ReactElement => {
  const [openCAC, setopenCAC] = useState(false)
  const [cacSelectedMethod, setcacSelectedMethod] = useState('')
  const [comuna, setComuna] = useState('')
  const [comunaList, setComunaList] = useState([])
  const [deliveryMethod, setDeliveryMethod] = useState(false)
  const [storeSelectorButtonStatus, setStoreSelectorButtonStatus] =
    useState<ButtonStatus>('disabled')
  const [CACSelectorButtonStatus, setCACSelectorButtonStatus] =
    useState<ButtonStatus>('disabled')
  const [openStoreSelector, setStoreSelector] = useState(false)
  const [regionList, setRegionList] = useState([])
  const [store, setStore] = useState([])
  const [storeList, setStoreList] = useState([])
  const [storeMethod, setStoreMethod] = useState(false)
  const [failModal, setFailModal] = useState(false)
  const [failModalColorTitle, setFailModalColorTitle] = useState('')
  const [failModalButtonText, setFailModalButtonText] = useState('')
  const [failModalContent, setFailModalContent] = useState('')
  const [failModalTitle, setFailModalTitle] = useState('')
  const [titlePosition, setTitlePosition] =
    useState<TitleProps['textAlign']>('center')
  const [contentPosition, setContentPosition] =
    useState<TitleProps['textAlign']>('center')
  const [windowParams, setWindowParams] = useState('')

  const [storeSelected, setStoreSelected] = useState<StoreAddress>(null)
  const { handleAddressObject, data: updateData } = useUpdateAddress()
  const { trigger } = useTrigerEvent()
  const { data: orderFormData } = useOrderForm()

  useEvents({
    eventType: 'deliverySelector',
    callBack: ({ detail: { show, toStore } }) => {
      const addressSelected = orderFormData?.data?.selectedAddresses || ''
      if (addressSelected && !toStore) {
        const isPickup = addressSelected?.addressType == 'pickup-in-point'
        if (isPickup) {
          setStoreSelectorButtonStatus('initial')
          cacStore(addressSelected?.addressId ?? '')
        } else {
          cacDelivery()
          setopenCAC(false)
        }
      } else {
        setStoreMethod(false)
        setDeliveryMethod(false)
        setcacSelectedMethod('')
        setopenCAC(show)
        setCACSelectorButtonStatus('disabled')
        if (toStore !== undefined) {
          cacStore()
        }
      }
      setcacSelectedMethod('')
    }
  })

  // errors
  const [storesAddressError, setStoresAddressError] = useState(false)
  const [coordsValidateError, setCoordsValidateError] = useState(false)
  const [addressObjectError, setAddressObjectError] = useState(false)

  // store selector functions

  const findSelectedStore = storeList.findIndex((storeSelect) => {
    return storeSelect.selected === true
  })

  const storeSelector = (data, index) => {
    if (findSelectedStore !== -1) {
      storeList[findSelectedStore].selected = false
      storeList[index].selected = true
      setStoreList([...storeList])
    } else {
      if (storeList[index]) {
        storeList[index].selected = true
        setStoreList([...storeList])
      }
    }
    setStoreSelected(data)
    setStoreSelectorButtonStatus('initial')
  }

  const storeSelectorButton = async () => {
    if (storeSelected) {
      const eventLabel = `Unimarc ${storeSelected.neighborhood}`.toLowerCase()
      eventClick({
        eventCategory: 'seleccion de metodo de entrega',
        'event-label': eventLabel
      })
      setStoreSelectorButtonStatus('loading')
      const response = await postCoordsValidate({
        data: storeSelected.geoCoordinates
      })
      if (!response?.data?.error) {
        handleAddressObject({
          ...storeSelected,
          salesChannel: response.data.sc,
          receiverName: storeSelected.name
        })
      } else {
        setStoreSelectorButtonStatus('disabled')
        setCoordsValidateError(true)
      }
    }
    return false
  }

  useEffect(() => {
    if (updateData) {
      if (updateData?.data?.error) {
        setStoreSelectorButtonStatus('disabled')
        setAddressObjectError(true)
      } else {
        setStoreSelector(false)
        trigger({ eventType: 'deliverySelector', data: { show: false } })
        setStoreSelectorButtonStatus('disabled')
      }
    }
  }, [updateData])

  const deleteSelectedStore = () => {
    if (
      findSelectedStore !== -1 &&
      storeList[findSelectedStore].selected === true
    ) {
      storeList[findSelectedStore].selected = false
      setStoreList([...storeList])
    }
  }

  const regionSelector = (e) => {
    if (e.target.value === 'Seleccionar región') {
      setStoreList(store)
    } else {
      deleteSelectedStore()
      const filterStore = store.filter((elem) => {
        return elem.region === e.target.value
      })
      setComunaList(
        filterStore.map((elem) => {
          return elem.neighborhood
        })
      )
      setStoreList(filterStore)
      setStoreSelected(null)
      setStoreSelectorButtonStatus('disabled')
      setComuna('')
    }
  }

  const comunaSelector = (e) => {
    if (e.target.value === 'Seleccionar comuna') {
      setStoreList(store)
      setComuna('')
    } else {
      deleteSelectedStore()
      setComuna(e.target.value)
      const filterStore = store.filter((elem) => {
        return elem.neighborhood === e.target.value
      })
      setStoreList(filterStore)
      setStoreSelected(null)
      setStoreSelectorButtonStatus('disabled')
    }
  }

  // delivery selector functions
  const selectDeliveryMethod = () => {
    eventClick({
      eventCategory: 'interacciones en metodo de entrega',
      'event-label': 'boton confirmar como quieres recibir tu compra'
    })
    if (!deliveryMethod) {
      setDeliveryMethod(!deliveryMethod)
      setStoreMethod(false)
      setcacSelectedMethod('residential')
      setCACSelectorButtonStatus('initial')
    }
  }

  const selectStoreMethod = () => {
    if (!storeMethod) {
      setStoreMethod(!storeMethod)
      setDeliveryMethod(false)
      setcacSelectedMethod('pickup-in-point')
      setCACSelectorButtonStatus('initial')
    }
  }

  const changeDeliveryMethod = async () => {
    trigger({ eventType: 'storeLocator', data: { toCC: true } })
    setStoreSelector(false)
  }

  const cacDelivery = () => {
    setopenCAC(!openCAC)
    trigger({ eventType: 'storeLocator', data: { show: true } })
  }

  const cacStore = async (addressId?: string) => {
    setWindowParams('')
    setCACSelectorButtonStatus('loading')
    const responseNewAddress = await getStoresAddress()
    if (!responseNewAddress.error) {
      const {
        data: {
          clientProfileData: { firstName, lastName }
        }
      } = orderFormData
      const regionFormated: string[] = []
      const stores = []
      responseNewAddress.data.forEach((element) => {
        regionFormated.push(element.name)
        element.neighborhood.forEach((storeListed) => {
          storeListed.store.forEach((info) => {
            stores.push({
              addressId: info.addressId,
              addressType: info.addressType,
              city: info.city,
              country: info.country,
              formatedAddress: `${info.street} ${info.number}, ${info.neighborhood}`,
              geoCoordinates: info.geoCoordinates,
              id: info.id,
              neighborhood: info.neighborhood,
              number: info.number,
              region: element.name,
              selected: addressId ? addressId === info.addressId : false,
              state: info.state,
              storeName: storeListed?.name,
              name: `${firstName} ${lastName}`,
              street: info.street
            })
          })
        })
      })
      const finalRegion = removeItem(
        [...regionFormated].sort((regionA, regionB) => {
          return regionA.localeCompare(regionB)
        }),
        'Region Metropolitana'
      )
      finalRegion.unshift('Region Metropolitana')
      setRegionList(finalRegion)
      setStoreList(stores)
      setStore(stores)
      setopenCAC(false)
      setStoreSelector(!openStoreSelector)
      for (let index = 0; index < stores.length; index++) {
        const storeIterated = stores[index]
        if (storeIterated.selected) storeSelector(storeIterated, index)
      }
    } else {
      setStoresAddressError(true)
    }
  }

  const selectorMethodEventLabel = () => {
    return cacSelectedMethod === 'residential'
      ? 'despacho a domicilio'
      : 'retiro en tienda'
  }

  const cacSelectorButton = () => {
    eventClick({
      eventCategory: 'seleccion de la tienda',
      'event-label': selectorMethodEventLabel()
    })
    if (orderFormData.data.selectedAddresses) {
      if (
        cacSelectedMethod !== orderFormData.data.selectedAddresses.addressType
      ) {
        setFailModal(!failModal)
        setFailModalColorTitle(getGlobalStyle('--color-primary-red'))
        setTitlePosition('left')
        setContentPosition('left')
        setFailModalTitle(
          '¿Estás seguro que quieres cambiar el tipo de entrega?'
        )
        setFailModalButtonText('Cambiar tipo de entrega')
        setFailModalContent(
          'Para cambiar el tipo de entrega, te redirigiremos a tus direcciones. Es posible que los productos que quieres comprar no se encuentren disponibles en la nueva ubicación o tienda.'
        )
      } else {
        if (
          orderFormData.data.selectedAddresses.addressType ===
          AddressType.Delivery
        ) {
          cacDelivery()
        }
        if (
          orderFormData.data.selectedAddresses.addressType === AddressType.Store
        ) {
          cacStore()
        }
      }
    } else {
      if (cacSelectedMethod === AddressType.Delivery) {
        cacDelivery()
      }
      if (cacSelectedMethod === AddressType.Store) {
        cacStore()
      }
    }
  }

  const errorModal = () => {
    setFailModal(!failModal)
  }

  const errorModalAction = () => {
    if (
      orderFormData.data.selectedAddresses.addressType === AddressType.Delivery
    ) {
      cacStore()
      setFailModal(!failModal)
    }
    if (
      orderFormData.data.selectedAddresses.addressType === AddressType.Store
    ) {
      cacDelivery()
      setFailModal(!failModal)
    }
  }

  // close functions
  const closeDeliverySelector = () => {
    setopenCAC(!openCAC)
    setStoreMethod(false)
    setDeliveryMethod(false)
    setcacSelectedMethod('')
    setDeliveryMethod(false)
    setStoreMethod(false)
    setcacSelectedMethod('')
  }

  const closeStoreSelector = () => {
    setStoreSelector(false)
    setStoreMethod(false)
    setDeliveryMethod(false)
    setcacSelectedMethod('')
    setDeliveryMethod(false)
    setStoreMethod(false)
    setcacSelectedMethod('')
    setStoreSelectorButtonStatus('disabled')
  }

  // errors useEffect
  useEffect(() => {
    if (storesAddressError) {
      throw new Error('Error en la obtención de direcciones de tiendas')
    }
    if (coordsValidateError) {
      throw new Error('Error en la validación de coordenadas de tiendas')
    }
    if (addressObjectError) {
      throw new Error('Error en el seteo de tienda')
    }
  }, [storesAddressError, coordsValidateError, addressObjectError])

  useEffect(() => {
    if (orderFormData?.data) {
      if (windowParams === 'store') {
        setcacSelectedMethod('pickup-in-point')
        cacStore()
      }

      if (windowParams === 'delivery') {
        setcacSelectedMethod('residential')
        trigger({ eventType: 'storeLocator', data: { show: true } })
      }
      if (windowParams === '?sl=true') {
        setopenCAC(true)
      }
    }
  }, [orderFormData])

  useEffect(() => {
    if (validateWindow()) {
      const locationSearch = window.location.search.split('?delivery-type=')[1]
      if (locationSearch === 'store') {
        setWindowParams(locationSearch)
      }
      if (locationSearch === 'delivery') {
        setWindowParams(locationSearch)
      }
      if (window.location.search.includes('?sl=true')) {
        setWindowParams('?sl=true')
      }
    }
  }, [typeof window])

  const deliverySelectorTypeProps = {
    CACSelectorButtonStatus,
    comunaList,
    comunaSelected: comuna,
    contentPosition,
    enabledDeliverySelector: deliveryMethod,
    enabledStoreSelector: storeMethod,
    failModalButtonText,
    failModalColorTitle,
    failModalContent,
    failModalIsOpen: failModal,
    failModalTitle,
    openDeliverySelector: openCAC,
    openStoreSelector,
    regionList,
    storeList,
    storeSelectorButtonStatus,
    titlePosition,
    activeDeliverySelector: selectDeliveryMethod,
    activeStoreSelector: selectStoreMethod,
    cacSelectorButton,
    changeDeliveryMethod,
    closeDeliverySelector,
    closeStoreSelector,
    comunaSelector,
    errorModal,
    errorModalAction,
    regionSelector,
    storeSelector,
    storeSelectorButton
  }

  return <DeliverySelectorType {...deliverySelectorTypeProps} />
}
